import { render, staticRenderFns } from "./IncomeInformation.vue?vue&type=template&id=774eb78a&scoped=true"
import script from "./IncomeInformation.vue?vue&type=script&lang=ts"
export * from "./IncomeInformation.vue?vue&type=script&lang=ts"
import style0 from "./IncomeInformation.vue?vue&type=style&index=0&id=774eb78a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774eb78a",
  null
  
)

export default component.exports